import { useCallback, useEffect, useRef } from "react";

export const STUDY_BUDDY_PARENT_ORIGIN = "https://articulate.com.sg";

export function measureStudyBuddyDocumentHeight() {
  const body = document.body;
  const root = document.documentElement;
  return Math.max(
    body?.scrollHeight || 0,
    body?.offsetHeight || 0,
    body?.clientHeight || 0,
    root?.scrollHeight || 0,
    root?.offsetHeight || 0,
    root?.clientHeight || 0
  );
}

export default function useStudyBuddyIframeHeight(enabled = true) {
  const containerRef = useRef(null);
  const frameRef = useRef(null);
  const lastHeightRef = useRef(null);

  const scheduleReport = useCallback(() => {
    if (!enabled || window.parent === window || frameRef.current !== null) return;
    frameRef.current = window.requestAnimationFrame(() => {
      frameRef.current = null;
      const height = measureStudyBuddyDocumentHeight();
      if (!Number.isFinite(height) || height <= 0 || height === lastHeightRef.current) return;
      lastHeightRef.current = height;
      window.parent.postMessage({ type: "resize-study-buddy-iframe", height }, STUDY_BUDDY_PARENT_ORIGIN);
    });
  }, [enabled]);

  useEffect(() => {
    if (!enabled || window.parent === window) return undefined;
    let observer;
    scheduleReport();
    window.addEventListener("resize", scheduleReport);
    if (typeof window.ResizeObserver === "function") {
      observer = new window.ResizeObserver(scheduleReport);
      observer.observe(containerRef.current || document.documentElement);
    }
    return () => {
      observer?.disconnect();
      window.removeEventListener("resize", scheduleReport);
      if (frameRef.current !== null) {
        window.cancelAnimationFrame(frameRef.current);
        frameRef.current = null;
      }
    };
  }, [enabled, scheduleReport]);

  return containerRef;
}
